module.exports = __webpack_public_path__ + "static/media/icon-loupe.1086ec3b.svg";